<div class="mypanel">
	<flx-accordion-button [iconColor]="opened ? 'primary' : 'default'" [arrow]="opened ? 'up' : 'down'" [color]="opened ? 'primary' : 'default'" (click)="toggleOpen()">
		{{ title }}
	</flx-accordion-button>
	<div class="body" [ngClass]="{ hidden: !opened }"><ng-content></ng-content></div>
	<div></div>
</div>
